export default __webpack_public_path__ + "static/media/fs-ii-suggestion.3d02bb47.svg";